import React from 'react'
import styles from './ProgressBanner.module.css'
import { PROGRESS_BANNER_IMAGES } from './constants'

interface ProgressBannerHeaderProps {
    title?: string
    subtitleSp?: string
    subtitlePc?: string
}

export const ProgressBannerHeader = ({ title, subtitleSp, subtitlePc }: ProgressBannerHeaderProps) => {
    return (
        <>
            <div className={styles.sparklingLeft}>
                <img
                    src={PROGRESS_BANNER_IMAGES.DECORATION_LEFT}
                    alt="decoration-left"
                />
            </div>
            <div className={styles.sparklingRight}>
                <img
                    src={PROGRESS_BANNER_IMAGES.DECORATION_RIGHT}
                    alt="decoration-right"
                />
            </div>
            <div className={styles.headerContent}>
                <div className={styles.logo}>
                    <img
                        src={PROGRESS_BANNER_IMAGES.LOGO}
                        alt="Foodslabo"
                    />
                </div>
                {title && (
                    <div className={styles.registerTitle}>{title}</div>
                )}
                {(subtitleSp || subtitlePc) && (
                    <div className={styles.registerSubtitle}>
                        <span className={styles.registerSubtitleSp}>
                            {subtitleSp}
                        </span>
                        <span className={styles.registerSubtitlePc}>
                            {subtitlePc}
                        </span>
                    </div>
                )}
            </div>
        </>
    )
}
